import React, { useContext, useEffect, useMemo, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CardsContext } from '../../CardsContext';
import { AppContext } from '../../../../AppContext';
import { SectionHead } from '../../../../components/SectionHead/SectionHead';
import { Card } from '../../../../components/Card';
import { sortByBool, sortByDate, sortByString } from '../../utils/utils';
import { useWindowSize } from '../../hooks/useWindowSize';
import { useFilteredCards } from '../../hooks/useFilteredCards';
import { sendPageViewEvent } from '../../../../utils/utils';
import './FilterPage.scss';

export function FilterPage({
  browse,
  filter,
  filterTitle,
  onBack,
  onToggleWatchLater
}) {
  const { target, isTargetClasses, cards, cardsConfig } = useContext(CardsContext);
  const { coaches } = useContext(AppContext);
  const windowSize = useWindowSize();
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const filteredCards = useFilteredCards(cards, filter, isTargetClasses);
  const resultCards = useMemo(() => {
    return filteredCards.sort(sortClasses(filter.sortBy, coaches));
  }, [filteredCards, filter.sortBy, coaches]);

  useEffect(() => {
    if(!browse) {
      sendPageViewEvent(`Poker Coaching ${target} | PokerCoaching.com`);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [browse, target, filter]);

  useEffect(() => {
    setCurrent(1);
  }, [resultCards]);

  useEffect(() => {
    if(windowSize.width >= 3840) {
      setPageSize(20);
    } else if(windowSize.width >= 1920) {
      setPageSize(16);
    } else {
      setPageSize(12);
    }
  }, [windowSize]);

  if(!resultCards?.length) {
    return <p className="no-data">No {target} for current filter</p>;
  }

  const visibleCards = resultCards.slice(0, current * pageSize);

  const sendCardClickToAnalytics = (card) => {
    // actid=10
    window.analytics?.track("object:click", {
      "object": target,
      "parent_object_title": filterTitle,
      "title": card.title,
      "url": card.url
    });
  }

  return (
    <div className="FilterPage">
      <SectionHead
        title={filterTitle}
        count={resultCards.length}
        action={{
          type: 'button',
          children: 'Back',
          arrow: 'left',
          onClick: onBack
        }}
      />

      <InfiniteScroll
        dataLength={visibleCards.length}
        next={() => setCurrent((prevCurrent) => prevCurrent + 1)}
        hasMore={visibleCards.length < resultCards.length}
        loader={<h4>Loading...</h4>}
        endMessage={null}
      >
        <div className="FilterPage__items">
          {visibleCards.map((cardItem) => (
            <Card
              isShowDate={isTargetClasses}
              isShowWatchLater={cardsConfig.watchLater}
              type={target}
              cardItem={cardItem}
              key={cardItem.id}
              onToggleWatchLater={onToggleWatchLater}
              onClick={() => sendCardClickToAnalytics(cardItem)}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
}

function sortClasses(sortBy, coaches) {
  switch(sortBy) {
    case 'Upload date':
      return (a, b) => sortByDate(a.date, b.date);
    case 'Coach':
      return (a, b) => sortByString(coaches.get(a.coach[0]).title, coaches.get(b.coach[0]).title);
    case 'Watched':
      return (a, b) => sortByBool(a.watched, b.watched);
    default:
      return (a, b) => 0;
  }
}
